export function maskPhone(phoneNumber) {
  let phone = removeCharacters(phoneNumber);

  if (phone.startsWith(55)) {
    phone = phone.slice(2);
  }

  const ddd = phone.slice(0, 2);
  const numberMask = phone.slice(2, -4).replace(/./g, "*");
  const lastDigist = phone.slice(-4);

  return `(${ddd}) ${numberMask}${lastDigist}`;
}

export function maskEmail(email) {
  const [localPart, domain] = email.split("@");

  return `${localPart.slice(0, 1)}${localPart
    .slice(1, localPart.length - 2)
    .replace(/./g, "*")}${localPart.slice(-2)}@${domain}`;
}

function removeCharacters(phoneNumber) {
  return phoneNumber.replace(/[^0-9]/g, "");
}
